<template>
  <div>
    <h1 class="text-2xl mb-6">Configuration des Utms</h1>
    <DailyReportUtmTable ref="dailyReportUtmTable"></DailyReportUtmTable>
    <v-row justify="center" class="mt-6 mb-6">
      <v-btn class="primary" @click="dialog = true"
        >Ajouter un nouvel utm</v-btn
      >
    </v-row>
    <v-dialog v-model="dialog">
      <UtmCreation
        @close-dialog="dialog = false"
        @saved="handleUtmSaved"
      ></UtmCreation>
    </v-dialog>
    <v-snackbar v-model="showSuccessMessage" color="success" timeout="3000" top>
      Config crée avec succès
    </v-snackbar>
  </div>
</template>
<script>
import DailyReportUtmTable from "@/components/acquisition/daily-report/tables/DailyReportUtmTable";
import UtmCreation from "@/components/acquisition/daily-report/cards/UtmCreation.vue";
export default {
  name: "ArbitrageDailyReportUtm",
  components: { DailyReportUtmTable, UtmCreation },
  data() {
    return {
      utm: {
        id: "",
        source: "",
        campaign: "",
        acqui_platform_id: "",
      },
      dialog: false,
      showSuccessMessage: false,
    };
  },
  methods: {
    handleUtmSaved() {
      this.dialog = false;
      this.showSuccessMessage = true;
      this.$refs.dailyReportUtmTable.getData();
    },
  },
};
</script>
<style></style>
